import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    passwordReset: false,
    username: null,
    otp: null,
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        RESET_PASSWORD_INITIATE: (state, action) => {
            state.loading = false;
            state.passwordReset = true;
            state.username = action.payload;
            state.otp = null;
        },
        RESET_PASSWORD_OTP_UPDATE: (state, action) => {
            state.loading = false;
            state.passwordReset = true;
            state.username = state.username;
            state.otp = action.payload;
        },
        RESET_PASSWORD_SUCCESS: (state) => {
            state.loading = false;
            state.passwordReset = false;
            state.username = null;
            state.otp = null;
        },
    },
})

export const { RESET_PASSWORD_INITIATE, RESET_PASSWORD_OTP_UPDATE, RESET_PASSWORD_SUCCESS } = authSlice.actions

export default authSlice.reducer;
